import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import FooterLogo from './FooterLogo';
import Logo from './Logo';
import { colors } from '../style/tokens';
import { headerBg } from '../style/header';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--sfondo, ${colors.bg});
  font-family: 'Outfit', sans-serif;
  overflow-y: auto;
`;

const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 26px;
  min-height: 82px;
  flex-shrink: 0;
  position: relative;
  background: ${headerBg};
`;

const LogoCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 20px;
  padding: 32px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.text};
  margin: 0;
`;

const Message = styled.p`
  font-size: 14px;
  color: ${colors.muted};
  line-height: 1.6;
  max-width: 320px;
  margin: 0;
`;

/**
 * TEMPORARY (redirect-on-expiry): shown when the JWT has expired and there is
 * no redirect target (no `return_url` claim and no captured referrer), so we
 * can't send the user anywhere automatically. Asks them to navigate back to
 * the page that linked them here.
 */
const SessionEnded: React.FC = () => {
  const intl = useIntl();
  return (
    <Page>
      <TopBar>
        <span style={{ width: 42 }} />
        <LogoCenter><Logo /></LogoCenter>
        <span style={{ width: 42 }} />
      </TopBar>
      <Body>
        <Title>{intl.formatMessage({ id: 'sessionEnded.title' })}</Title>
        <Message>{intl.formatMessage({ id: 'sessionEnded.message' })}</Message>
      </Body>
      <FooterLogo />
    </Page>
  );
};

export default SessionEnded;
